import * as React from 'react';

function SvgIconIncluded(props) {
  return (
    <svg viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fillRule="evenodd">
        <path
          d="M8.499 17a8.5 8.5 0 008.499-8.5A8.5 8.5 0 100 8.5 8.5 8.5 0 008.499 17z"
          fill="#38B2A6"
          fillRule="nonzero"
        />
        <path
          d="M7.57 9.072l3.711-3.713a1.25 1.25 0 111.768 1.768l-5.48 5.48-3.711-3.712a1.25 1.25 0 011.767-1.768L7.57 9.072z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIconIncluded;
